import { type SeriesObservation, shownReference } from '../observation/observation';
import { discountDepth } from './promotion';

/**
 * Unweighted mean discount depth: (listPrice − price) / listPrice, computed only
 * over observations where price < listPrice (D-03, AC-04). Zero-depth observations
 * do not enter the mean. Returns null when no discounted observations are present.
 */
export function computeDiscountDepth(obs: readonly SeriesObservation[]): number | null {
  let sum = 0;
  let count = 0;
  for (const o of obs) {
    const depth = discountDepth(o.observed.price, shownReference(o.observed));
    if (depth === null || depth <= 0) continue;
    sum += depth;
    count++;
  }
  return count > 0 ? sum / count : null;
}
